import { CoverageScreenType } from './coverage-type';

export const CoverageScreenShowDeductible = {
  contactUs: false,
  limited100Covered: true,
  manufacturerCovered: false,
  carvanaCareCovered: true,
  carvanaCareOilTireCovered: false,
  notCovered: false,
  thirtyDayCovered: true,
  conditionallyCoveredBrakes: false,
  notCoveredCosmetic: false,
  notCoveredGlass: false,
  notCoveredAdditionalCosmetic: false,
  notCoveredAdditionalKey: false,
  notCoveredMissingAccessories: false,
  cosmeticSubmitted: false,
};

export const showDeductible = (
  coverageScreenType: CoverageScreenType,
  deductible: any
): {
  inNetwork?: number;
  outOfNetwork?: number;
  show: boolean;
} => {
  const { inNetwork, outOfNetwork } = deductible || {};

  return {
    inNetwork,
    outOfNetwork,
    show: CoverageScreenShowDeductible[coverageScreenType],
  };
};
